import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { useCookies } from 'react-cookie';

import Button from './button';
import iconStethoscope from "../../images/icon-stethoscope.png";
import popupAccent from "../../images/gist-popup-accent.png";

Modal.setAppElement('#___gatsby'); // Set the app element for accessibility

const HcpModal = ({ children, isOpen, closeModal, site="" }) => {
    
  const [cookies, setCookie] = useCookies(['modalSeen']);
  const [btnTheme, setBtnTheme] = useState('yellow-sky-blue-navy');
  const [url, setUrl] = useState('https://www.ayvakit.com/');
  

  
  useEffect(()=>{
    switch (site) {
        case 'gist':
            console.log('gist');
            setBtnTheme('white-sky-blue-navy')
            setUrl('https://ayvakit.com/pdgfra-gist/')
            break;
        case 'ism':
            console.log('ism');
            setBtnTheme('yellow-white-deep-turquoise')
            setUrl('https://ayvakit.com/indolent-systemic-mastocytosis/')
            break;
        case 'advsm':
            console.log('advsm');
            setBtnTheme('sky-blue-white-yellow')
            setUrl('https://ayvakit.com/advanced-systemic-mastocytosis/')
            break;
        case 'gateway':
            console.log('gateway');
            setBtnTheme('yellow-white-deep-turquoise')
            setUrl('https://ayvakit.com/')
            break;
        default:
          console.log(`Sorry, we are out of ${site}.`);
          break;
      }
      console.log(cookies)
  });

  const handleCloseModal = () => {
    let newDate = new Date();
    // add a day
    newDate.setDate(newDate.getDate() + 1);
    setCookie('sitename', site, { path: '/', expires: newDate});
    closeModal();
  };

  if (!isOpen || cookies.sitename == site) {
    return null;
  }


  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleCloseModal}
      site={site}
      contentLabel="dd"
      shouldCloseOnOverlayClick={false}
    >
      <div className={"sp-header "+ site}>
        <div className='row mb-1 md_mb-1 lg_mb-1'>
            <div className='column shrink small-12 medium-3 mb-1'><Button type="icon" iconurl={iconStethoscope} site={site} /></div>
            <div className='column small-12 medium-9'><h5>The information contained in this site is intended for US healthcare professionals only.</h5></div>
        </div>
        <div className='row'>
            <div className='column small-12 medium-6'><Button onclick={handleCloseModal} site={site} type="btn" copy={"Yes, I am a US healthcare professional"} buttontheme={btnTheme}></Button></div>
            <div className='column small-12 medium-6 mt-1'><Button onclick={closeModal} url={url} target='_blank' site={site} copy={"No, I am not a US healthcare professional"} buttontheme={btnTheme}></Button></div>
        </div>
        <img src={popupAccent} id="popup-accent"/>
      </div>
    </Modal>
  );
};

export default HcpModal;
